import axios from '../api/axios'

export default {
    register(params, callback){ // 平台注册
        axios.post(`/oa/company/register`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    signIn(params, callback){ // 平台登录
        axios.post(`/oa/company/login`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    forgotPassword(params, callback){ // 忘记密码
        axios.post(`/oa/company/forgotPassword`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    updatePassword(params, callback){ // 修改密码
        axios.put(`/oa/company/updatePassword`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    signOut({callback}){ // 平台退出
        axios.post(`/logout`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    addContact({params, callback}){
        axios.post(`/oa/company/addContact`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/login.js